import { MappingTypeMapping } from '@elastic/elasticsearch/lib/api/types';
import { merge } from 'lodash';
import { z } from 'zod';

// NOTE: This file is used to define the Elasticsearch mappings for the base indexed documents.
// They ARE be defined in @nucleus/lib-elasticsearch, but I ran into trouble because it was
// causing the browser build to fail. This file is a workaround to allow the mappings to be
// defined in a way that is compatible with the browser.

export const BaseIndexDocumentSchema = z.object({
  id: z.string(),
});

export type BaseIndexDocument = z.infer<typeof BaseIndexDocumentSchema>;

export const BaseIndexDocumentMapping: MappingTypeMapping = {
  properties: {
    id: { type: 'keyword' },
  },
} as const;

export const BaseRoutedIndexDocumentSchema = BaseIndexDocumentSchema.extend({
  ownerId: z.string(),
});

export type BaseRoutedIndexDocument = z.infer<typeof BaseRoutedIndexDocumentSchema>;

export const BaseRoutedIndexDocumentMapping: MappingTypeMapping = merge({}, BaseIndexDocumentMapping, {
  properties: {
    ownerId: { type: 'keyword' },
  },
  _routing: {
    required: true,
  },
} as const);
